import React, { Fragment, useEffect, useState, useMemo } from "react";
import { CCollapse, CLink } from "@coreui/react";
import axios from "axios";
import moment from "moment";
import config from "../../config/config";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import { toastSuccess, toastError } from "../../common/Toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../common/Constant";
import { Noimage } from "../../common/imagePath";
import DeleteConfirmationModalBanner from "../Modal/DeleteConfirmation";
//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button, IconButton, MenuItem, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

function ClearanceProduct(props) {
  //const [visibleFeaturedProducts, setVisibleFeaturedProducts] = useState(false);
  const [visibleClearanceProduct, setVisibleClearanceProduct] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const [products, setProducts] = useState(props.visibleProductChange);

  // CALLBACK
  //const [featuredProducts, setFeaturedProducts] = useState([]);
  const [ClearanceProduct, setClearanceProduct] = useState([]);
  const [data, setdata] = useState([]);
  const callback = (payload) => {
    if (payload != undefined && payload != null && payload != "") {
      let manageolddata = [...ClearanceProduct, payload];

      setClearanceProduct(manageolddata);
    }
  };

  console.log(data, "data123");
  // CALLBACK

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const[data11,setdata11]=useState(true)

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  //UseEffect For Table
  useEffect(() => {
    axios
      .get(`${config.ecommconfigBaseUrl}/ecomconfig/getClearanceProduct`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setdata(res.data.ResponseID);
        return res;
      });
  }, [ClearanceProduct,deleteModalOpen]);
  //UseEffect For Table

  //handledelete
  const handlefeaturedProductsDelete = (index) => {
    // return true;
    const newfeaturedProducts = ClearanceProduct.filter((_, i) => i !== index);
    setClearanceProduct(newfeaturedProducts);
  };

  const columns = useMemo(() => [
    {
      header: "Item ID",
      accessorKey: "ItemID",
      size:"50",
    },
    {
      header: "Item Name",
      accessorKey: "ItemName",
    },
    {
      header: "Variation Name",
      accessorKey: "VariationName",
    },
    {
      header: "Quantity",
      accessorKey: "Quantity",
      size:"50",
      Cell: ({ row }) => {
        return parseFloat(row.original.Quantity).toFixed(2);
      },
    },
    {
      header: "Unit Price",
      accessorKey: "UnitPrice",
      size:"50",
      Cell: ({ row }) => {
        return parseFloat(row.original.UnitPrice).toFixed(2);
      },
    },
    {
      header: "Cost Price",
      accessorKey: "CostPrice",
      size:"50",
      Cell: ({ row }) => {
        return parseFloat(row.original.CostPrice).toFixed(2);
      },
    },
  ]);

  const openDeleteFunction = (row) => {


    const deleteRequestParam = {
      deleteid: row.original.ItemID, module: "ClearanceProduct"
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );

    setDeleteModalOpen(true);
    // axios
    //   .post(
    //     `${config.ecommconfigBaseUrl}/ecomconfig/deleteproducts`,
    //     { deleteid: row.original.ItemID, module: "ClearanceProduct" },
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     const deletedata = data.filter((item, index) => index !== row.index);
    //     setdata(deletedata);
    //   })
    //   .catch((error) => {
    //     // Handle error if any
    //     console.error("Error deleting review:", error);
    //   });
  };
  // TableColumns

  return (
    <>
      <Loader loading={loading} />
      <Fragment>
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">
              <CLink
                className="link"
                onClick={() => {
                  setVisibleClearanceProduct(!visibleClearanceProduct);
                  setProducts(!!products);
                }}
              >
                Clearance Products
              </CLink>
            </h5>
          </div>
          <CCollapse
            visible={visibleClearanceProduct || props.visibleProductChange}
          >
            <div class="card-body">
              <form>
                <div className="container-fluid">
                  <div class="d-flex ">
                    <div class="col-md-4">
                      <SearchableDropdown callback={callback} />
                    </div>
                  </div>
                </div>
              </form>
              <div
                className="table-responsive  mt-4"
                style={{ border: "1px solid rgba(0,0,0,.12)" }}
              >
                <MaterialReactTable
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  columns={columns}
                  data={data}
                  enableRowActions
                  // renderRowActions={({ row, table }) => (
                  //   <Box sx={{ display: "flex", gap: "1rem" }}>
                  //     <Tooltip title="Delete">
                  //       <IconButton
                  //         color="error"
                  //         onClick={() => openDeleteFunction(row)}
                  //       >
                  //         <DeleteIcon />
                  //       </IconButton>
                  //     </Tooltip>
                  //   </Box>
                  // )}

                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem
                      className="confirm-text"
                      to="#"
                      // key="delete"
                      title="Delete"
                      data-bs-toggle="modal"
                      // data-bs-target="#DeleteConfirmationModal"
                      onClick={() => openDeleteFunction(row)}
                    >
                      {/* <DeleteIcon /> */}
                      Delete
                    </MenuItem>,
                  ]}
                />
              </div>
            </div>
          </CCollapse>
        </div>
        <DeleteConfirmationModalBanner
        deleteApiUrl={`${config.ecommconfigBaseUrl}/ecomconfig/deleteproducts`}
        open={deleteModalOpen}
        data11={data11}
        onClose={() => setDeleteModalOpen(false)}
      />
      </Fragment>
    </>
  );
}

// SearchableDropdown
const SearchableDropdown = ({ callback }) => {
  const token = localStorage.getItem("Token");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [cursor, setcursor] = useState(0);
  const [tableData, setTableData] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);

  // const state = {
  //   example: "Hello",
  // };

  // const handleCallback = () => callback({ A: "hello" });

  useEffect(() => {
    // Fetch data from an API
    const fetchData = async () => {
      if (inputValue != "") {
        axios
          .get(
            `${config.itemsBaseUrl}/items/searchitem?searchparam=${inputValue}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response != "" && response != null) {
              const data = response.data.ResponseData;
              if (data[0].ItemId > 0) {
                setSuggestions(data);
              } else {
                setSuggestions([]);
              }
            }
          })
          .catch((error) => {});
      } else {
        setSuggestions([]);
      }
    };

    fetchData();
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleInputClick = (
    // event,
    pItemId,
    pItemName,
    pDescription,
    pVariationId,
    pAttributeId,
    pUnitPrice,
    pCostPrice,
    pQuantity,
    pVariationName
  ) => {
    const selectedOption = {
      ItemID: pItemId,
      ItemName: pItemName,
      Description: pDescription,
      VariationID: pVariationId,
      Quantity: pQuantity,
      AttributeId: pAttributeId,
      UnitPrice: pUnitPrice,
      CostPrice: pCostPrice,
      VariationName: pVariationName,
    };

    //setTableData([...tableData, selectedOption]);
    const data = {
      ClearanceProduct: pItemId,
    };

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/ClearanceProduct`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // setLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
      });
    setTableData(selectedOption);

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    const locationItemData = tableData;

    callback(locationItemData);
  }, [tableData]);

  return (
    <div className="container">
      <form>
        <div className="mb-3" style={{ position: "relative", width: "400px" }}>
          {/* <input type="text" className="form-control" value={inputValue} onChange={handleInputChange} /> */}
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <a href="google.com">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fill-rule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </a>
            </span>

            <input
              type="text"
              className="form-control h-auto"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div
            className="dropdown"
            style={{ position: "relative", width: "400px" }}
          >
            <ul
              className="dropdown-menu  show"
              style={{ width: "100%", maxHeight: "400px", overflowY: "auto" }}
            >
              {suggestions.map((item, index) => (
                <li
                  key={item.ItemId}
                  className={
                    cursor === index ? "dropdown-item active" : "dropdown-item"
                  }
                  onClick={(e) =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.UnitPrice,
                      item.CostPrice,
                      item.itemquantity,
                      item.VariationName
                    )
                  }
                >
                  <a
                    key={item.ItemId}
                    href="#"
                    className={
                      cursor === index
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    data-name={item.ItemName.toLowerCase()}
                    // onClick={handleInputClick(item.ItemId,item.ItemName)}
                  >
                    <img
                      src={
                        item.images
                          ? item.images
                          : Noimage
                      }
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle mr-5"
                      style={{
                        maxWidth: "55px",
                        maxHeight: "55px",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          Noimage;
                      }}
                    />
                    <div className="customer-info ml-2  ">
                      <h6 className="name">
                        {item.ItemName}
                        {item.VariationName ? `(${item.VariationName})` : ""}
                      </h6>
                      <div>
                        Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} |
                        Qty: {parseInt(item.itemquantity)} <br />
                        Categories: {item.CategoryName}
                      </div>
                      {/* Add any other customer details here */}
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </form>
    </div>
  );
};
// SearchableDropdown

export default ClearanceProduct;
